import { StaffManagement } from "@/components/StaffManagement";

export default function StaffManagementPage() {
  return <StaffManagement />;
}


